import React from 'react';
import { useManuals } from '../../contexts/ManualsContext';
import { TimesheetView } from './TimesheetView';
import { OvertimeView } from './OvertimeView';

export const ReportsSection = () => {
  const { activeManual } = useManuals();
  if (activeManual === 'timesheet') return <TimesheetView />;
  if (activeManual === 'overtime') return <OvertimeView />;
  return null;
};